import {
  Col,
  Row,
  Skeleton,
  Tag,
} from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Get } from "../../config/api/get";
import { PLAN } from "../../config/constants/api";
import Swal from "sweetalert2";
import { IoIosArrowRoundBack } from "react-icons/io";

const ViewPackage = () => {
  const token = useSelector((state) => state.user.userToken);
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [plan, setPlan] = useState(null);

  useEffect(() => {
    getPlan();
    // eslint-disable-next-line
  }, [id]);

  const getPlan = () => {
    setLoading(true);
    Get(PLAN.getPlanById + id, token, {})
      .then((response) => {
        console.log("Full API Response:", response);
        // Handle different response structures
        let planData = null;
        
        // Check if response has success and data
        if (response?.success && response?.data) {
          planData = response.data;
        } 
        // Check if response.data exists (even without success field)
        else if (response?.data) {
          planData = response.data;
        } 
        // Check if response itself is the plan object (has _id)
        else if (response?._id) {
          planData = response;
        }
        // Check if response has a nested structure
        else if (response?.data?.data) {
          planData = response.data.data;
        }
        
        console.log("Extracted planData:", planData);
        
        if (planData && planData._id) {
          setPlan(planData);
          setLoading(false);
        } else {
          setLoading(false);
          console.log("Plan data not found. Response structure:", JSON.stringify(response, null, 2));
          Swal.fire({
            title: "Error!",
            text: "Plan not found. Check console for details.",
            icon: "error",
            confirmButtonColor: "#d33",
          }).then(() => {
            navigate("/membershipPackages");
          });
        }
      })
      .catch((err) => {
        console.log("Error Fetching Plan:", err);
        console.log("Error Response:", err?.response);
        setLoading(false);
        // Check if error response has data
        if (err?.response?.data) {
          const errorData = err.response.data;
          console.log("Error Data:", errorData);
          // Check if error response actually contains the plan data
          if (errorData?.data?._id) {
            const planData = errorData.data;
            setPlan(planData);
            return;
          }
        }
        Swal.fire({
          title: "Error!",
          text: "Failed to load plan details",
          icon: "error",
          confirmButtonColor: "#d33",
        }).then(() => {
          navigate("/membershipPackages");
        });
      });
  };

  const handleEdit = () => {
    navigate(`/membershipPackages/edit/${id}`);
  };

  if (loading) {
    return (
      <Row justify="center">
        <Col md={23} xs={22}>
          <div
            className="bg-white rounded-lg sm:py-16 py-8 my-12"
            style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
          >
            <Skeleton active />
          </div>
        </Col>
      </Row>
    );
  }

  if (!plan) {
    return null;
  }

  return (
    <Row justify="center">
      <Col md={23} xs={22}>
        <div
          className="bg-white rounded-lg sm:py-16 py-8 my-12 px-4 sm:px-8"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <div className="flex justify-between mb-6">
            <div className="flex justify-center items-center">
              <IoIosArrowRoundBack
                onClick={() => navigate("/membershipPackages")}
                className="self-center cursor-pointer mr-1 w-[48px] h-[48px] max-sm:w-[24px] max-sm:h-[24px] text-black"
              />
              <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black">
                Package Details
              </h3>
            </div>
            <button
              className="uppercase bg-button py-3 px-2 laptop:px-12 text-black rounded-lg font-bold text-sm max-laptop:text-[8px] max-laptop:py-1 font-euclid"
              onClick={handleEdit}
            >
              Edit Package
            </button>
          </div>

          <Row justify="center">
            <Col xs={24}>
              <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-center justify-center sm:py-12 py-8 px-6 sm:px-8">
                <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black mb-8">
                  {plan.title}
                </h3>
                {plan.isPopular && (
                  <div className="mb-6">
                    <Tag color="orange" className="text-sm px-4 py-1">POPULAR</Tag>
                  </div>
                )}

                <div className="flex justify-center items-start my-4 w-full px-4 sm:px-8">
                  <div className="flex flex-col items-start lg:mr-32 mr-8 flex-1">
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2">
                      Type
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      {plan.hoursType}
                    </p>
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2">
                      Hours
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      {plan.hours || 0} hours
                    </p>
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2">
                      Booking Duration
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      {plan.bookingDuration} hours
                    </p>
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2">
                      Actual Amount
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      ${plan.actualAmount?.toLocaleString()}
                    </p>
                  </div>
                  <div className="flex flex-col items-start flex-1">
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2">
                      Discount
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      {plan.savePercent}%
                    </p>
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2">
                      Discounted Amount
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      ${plan.discountedAmount?.toLocaleString()}
                    </p>
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-2">
                      Total Hours
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      {plan.totalHours || plan.hours} hours
                    </p>
                  </div>
                </div>
                
                {plan.features && Array.isArray(plan.features) && plan.features.length > 0 && (() => {
                  // Ensure features is an array
                  let featuresArray = plan.features;
                  if (!Array.isArray(featuresArray)) {
                    featuresArray = Object.values(featuresArray);
                  }
                  
                  // Sort features by index
                  const sortedFeatures = [...featuresArray].filter(f => f !== null && f !== undefined).sort((a, b) => {
                    const indexA = typeof a === 'object' && a && a.index !== undefined ? a.index : 999;
                    const indexB = typeof b === 'object' && b && b.index !== undefined ? b.index : 999;
                    return indexA - indexB;
                  });
                  
                  return (
                    <div className="w-full px-4 sm:px-8 mt-4">
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-4 text-left">
                        Features
                      </h5>
                      <ul className="list-disc list-inside space-y-2 pl-4">
                        {sortedFeatures.map((feature, index) => {
                          // Safely extract feature text
                          let featureText = '';
                          if (typeof feature === 'string') {
                            featureText = feature;
                          } else if (feature && typeof feature === 'object' && feature.text) {
                            featureText = feature.text;
                          } else {
                            featureText = String(feature);
                          }
                          
                          return (
                            <li key={`feature-${index}`} className="font-euclid text-sm max-sm:text-xs text-gray-700">
                              {index + 1}. {featureText}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  );
                })()}
              </div>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default ViewPackage;

